import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("auth_token");
    const storedUser = localStorage.getItem("auth_user");
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const fetchCurrentUser = async (accessToken) => {
    const res = await axios.get(`${API_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return res.data;
  };

  const loginWithEmail = async (email, password) => {
    const formData = new URLSearchParams();
    formData.append("username", email);
    formData.append("password", password);

    const res = await axios.post(`${API_URL}/auth/login`, formData.toString(), {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    
    const accessToken = res.data.access_token;
    const userProfile = await fetchCurrentUser(accessToken);
    setToken(accessToken);
    setUser(userProfile);
    localStorage.setItem("auth_token", accessToken);
    localStorage.setItem("auth_user", JSON.stringify(userProfile));
  };

  const registerWithEmail = async (email, password, fullName) => {
    await axios.post(`${API_URL}/auth/register`, {
      email,
      password,
      full_name: fullName,
    });
    await loginWithEmail(email, password);
  };

  const loginWithGoogle = async (idToken) => {
    const res = await axios.post(`${API_URL}/auth/google`, {
      id_token: idToken,
    });
    const accessToken = res.data.access_token;
    const userProfile = await fetchCurrentUser(accessToken);
    setToken(accessToken);
    setUser(userProfile);
    localStorage.setItem("auth_token", accessToken);
    localStorage.setItem("auth_user", JSON.stringify(userProfile));
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
  };

  const value = {
    user,
    token,
    loading,
    loginWithEmail,
    registerWithEmail,
    loginWithGoogle,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
